// @flow

import { Component } from '../jsti/core';
import Template from '../classes/Template';
import FilterGroups from '../constants/FilterGroups';
import Notifications from '../constants/Notifications';

export default class SelectedFilters extends Component {
  #content: HTMLElement;
  #template: HTMLElement;
  #group: HTMLElement;
  hiddenClass: string = 'hidden';

  /**
   * Initialize the selected filters
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setUp(pEl);

    this.addListener(Notifications.FILTERED, this.onFiltered);
  }

  /**
   * Setup properties and validation
   */
  setUp(pEl: HTMLElement): void {
    const content: HTMLElement | null = pEl.querySelector('.filter__content');
    if (content) {
      this.#content = content;
    } else {
      throw new Error('Content is required');
    }

    const template: HTMLElement | null = content.querySelector('template[ref="selected"]');
    if (template) {
      this.#template = Template.getContent(template);
    } else {
      throw new Error('A template tag is required');
    }

    const group: any = pEl.parentElement;
    if (group) {
      this.#group = group;
    } else {
      throw new Error('A list item (group) is required');
    }
  }

  /**
   * Executes the user has filtered
   */
  onFiltered({ data }: Object): void {
    this.resetFilters();

    data.filterGroups.forEach((group: Object) => {
      if (group.type !== FilterGroups.SELECTED) return;
      if (!group.filters.length) return;
      this.#group.classList.remove(this.hiddenClass);
      this.addFilters(group.filters);
    });
  }

  /**
   * Add filters to the wrapper
   */
  addFilters(filters: Array<Object>): void {
    filters.forEach((filter: Object) => {
      const element: HTMLElement = this.buildFilter(filter.id, filter.name, filter.groupId);
      this.#content.insertBefore(element, this.#content.lastElementChild);
    });
  }

  /**
   * Reset all filters
   */
  resetFilters(): void {
    this.#group.classList.add(this.hiddenClass);
    this.#content.querySelectorAll('[ref="selected-filter"]').forEach((filter: HTMLElement) => {
      filter.remove();
    });
  }

  /**
   * Build a single selected filter
   */
  buildFilter(id: string, name: string, group: string) {
    const filter: HTMLElement = this.#template.cloneNode(true);
    const label: any = filter.firstElementChild;
    filter.dataset.id = id;
    filter.dataset.name = name;
    filter.dataset.group = group;
    label.textContent = name;
    return filter;
  }
}
